module.exports = __webpack_public_path__ + "img/border-line.838189d7.png";